
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("573SD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $972be7fe8de21e3b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $972be7fe8de21e3b$export$2e2bcd8739ae039 = {
    'fabric.linkPicker.button.cancel': 'Annuleren',
    'fabric.linkPicker.button.insert': 'Invoegen',
    'fabric.linkPicker.button.save': 'Opslaan',
    'fabric.linkPicker.clearLink': 'Wissen',
    'fabric.linkPicker.clearLinkText': 'Tekst wissen',
    'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {geen resultaten gevonden} one {{count,number} resultaat gevonden} other {{count,number} resultaten gevonden}}',
    'fabric.linkPicker.linkAriaLabel': 'Typ of plak een link in het veld',
    'fabric.linkPicker.linkHelperTextAriaLabel': 'Hulptekst van de linkweergave',
    'fabric.linkPicker.linkHelperTextLabel': 'Geef deze link een titel of omschrijving',
    'fabric.linkPicker.linkInvalid': 'Voer een geldige URL in.',
    'fabric.linkPicker.linkLabel': 'Link',
    'fabric.linkPicker.linkPlaceholder': 'Link plakken',
    'fabric.linkPicker.linkTextAriaLabel': 'Weergavetekst van de link',
    'fabric.linkPicker.linkTextLabel': 'Tekst weergeven (optioneel)',
    'fabric.linkPicker.linkTextPlaceholder': 'Tekst om te tonen',
    'fabric.linkPicker.listTitle.recentlyViewed': 'Recent bekeken',
    'fabric.linkPicker.listTitle.results': 'Resultaten',
    'fabric.linkPicker.noEmbed': 'De insluitweergave wordt niet ondersteund voor deze link. <a>Meer informatie over waarom sommige Smart Links geen inhoud weergeven.</a>',
    'fabric.linkPicker.search.error.description': 'Vernieuw de pagina of neem contact op met <a>Atlassian-support</a> als dit blijft gebeuren.',
    'fabric.linkPicker.search.error.heading': 'Er zijn wat problemen met het laden van de gegevens.',
    'fabric.linkPicker.search.error.retry': 'Vernieuwen',
    'fabric.linkPicker.search.linkAriaLabel': 'Suggesties verschijnen hieronder zodra je in het veld typt',
    'fabric.linkPicker.search.linkLabel': 'Zoeken of een link plakken',
    'fabric.linkPicker.search.linkPlaceholder': 'Zoek recente links of plak een nieuwe link',
    'fabric.linkPicker.search.noResults.description': 'Probeer het opnieuw met een andere term.',
    'fabric.linkPicker.search.noResults.heading': 'We hebben geen overeenkomsten gevonden voor je zoekopdracht.',
    'fabric.linkPicker.status.submitting': 'Wordt ingediend',
    'fabric.linkPicker.time.message.updated': 'Bijgewerkt: {time}',
    'fabric.linkPicker.time.message.viewed': 'Bekeken: {time}',
    'fabric.linkPicker.unhandledError.description': 'Probeer de pagina opnieuw te laden.',
    'fabric.linkPicker.unhandledError.heading': 'Er is iets misgegaan.'
};

});


//# sourceMappingURL=nl.5a29516b.js.map
